import React from 'react';
import { Badge } from 'react-bootstrap';

interface ISectionTitle {
    title: string;
    badge?: string;
}

export default function SectionTitle({ title, badge }: ISectionTitle) {
    return (
        <div className="section-title d-flex align-items-center gap-2 mb-4 mt-2">
            <h5 className="section-title-text text-uppercase fw-bold mb-0 text-muted">{title}</h5>
            {badge && (
                <Badge bg="warning" text="dark" className="section-title-badge">
                    {badge}
                </Badge>
            )}
            <div className="flex-grow-1 border-bottom ms-2" />
        </div>
    );
}
